import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import { portfolioData } from '../mock';

const Footer = () => {
  const { personal } = portfolioData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Name/Logo */}
          <div className="flex items-center gap-2">
           <div className="relative">
  <img
    src="/images/logo.png"
    alt="Aditya Singh Logo"
    className="w-8 h-8 object-contain shrink-0"
  />
</div>
            <div className="text-xl font-bold">
              <span className="text-white">Aditya</span>
              <span className="text-cyan-400 ml-1">AKS</span>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a
              href={`mailto:${personal.email}`}
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 hover:scale-110 transform"
              aria-label="Email"
            >
              <Mail size={24} />
            </a>
            <a
              href={`${personal.linkedIn}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 hover:scale-110 transform"
              aria-label="LinkedIn"
            >
              <Linkedin size={24} />
            </a>
            <a
              href={`${personal.github}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 hover:scale-110 transform"
              aria-label="GitHub"
            >
              <Github size={24} />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-gray-500 text-sm text-center">
            <p>© {currentYear} {personal.name}. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;